'use client';

import { Box } from '@mui/material';
import React from 'react';

import DemoModeBanner from 'components/DemoModeBanner';
import { useFeatureFlag } from 'components/FeatureFlag/Provider';
import env from 'config/env';

import { AppLayoutBase, AppLayoutRow, DemoLayoutWrapper, DemoOutline } from './AppLayout.styled';

export const AppLayout: React.FC<React.ComponentProps<typeof Box>> = ({ children, ...rest }) => {
  const hideBanner = useFeatureFlag('hide-demo-banner');

  if (!env.MOCKED) {
    return <AppLayoutBase {...rest}>{children}</AppLayoutBase>;
  }

  return (
    <DemoLayoutWrapper hideBanner={hideBanner} {...rest}>
      {!hideBanner && <DemoModeBanner />}
      <AppLayoutRow>{children}</AppLayoutRow>
      {!hideBanner && <DemoOutline />}
    </DemoLayoutWrapper>
  );
};
